export const dataUrl = process.env.REACT_APP_DATA_URL